import { render, staticRenderFns } from "./PasswordNewReveal.vue?vue&type=template&id=53cfe7a4&scoped=true&"
import script from "./PasswordNewReveal.vue?vue&type=script&lang=js&"
export * from "./PasswordNewReveal.vue?vue&type=script&lang=js&"
import style0 from "./PasswordNewReveal.vue?vue&type=style&index=0&id=53cfe7a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cfe7a4",
  null
  
)

/* custom blocks */
import block0 from "./PasswordNewReveal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

component.options.__file = "PasswordNewReveal.vue"
export default component.exports